import React from "react";

import { connect } from 'react-redux';
import UserBioComponent from './UserBioComponent';
import { teamProfileOperations } from './duck';
import { remove } from "js-cookie";

const mapStateToProps = ({ locationReducer, appReducer }) => {
  return {
    locationId: locationReducer.location_code,
    locationSettings: appReducer.location.settings,
  };
};

const mapDispatchToProps = (dispatch) => {

  const updateUserProfileDispatch = (userId, payload) => {
    dispatch(teamProfileOperations.updateUserOperation(userId, payload));
  }

  const updateUserPrivilegeDispatch = (userPrivilegeId, payload) => {
    dispatch(teamProfileOperations.updateUserPrivilegeOperation(userPrivilegeId, payload));
  }

  const removeAvatarDispatch = (userId) => {
    dispatch(teamProfileOperations.removeUserAvatarOperation(userId));
  }

  const removeUserPrivilegeDispatch = (userPrivilegeId, callback) => {
    dispatch(teamProfileOperations.removeUserPrivilegeOperation(userPrivilegeId, callback));
  }

  return { updateUserProfileDispatch, updateUserPrivilegeDispatch, removeAvatarDispatch, removeUserPrivilegeDispatch };
};

const UserBioContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(UserBioComponent);

export default UserBioContainer;
